import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAbility } from '@casl/react';
import { AbilityContext } from '../config/ability';

const ProtectedRoute = ({ children, action, subject }) => {
    const ability = useAbility(AbilityContext);
    const token = localStorage.getItem('token');

    if (!token) {
        return <Navigate to="/login" />;
    }

    if (ability.can(action, subject)) {
        return children;
    }
    
    // Se não tiver permissão, redireciona para dashboard (ou 403)
    // Se já estiver no dashboard e não tiver permissão (ex: participante tentando acessar algo), fica no loop?
    // Melhor redirecionar para uma página de "Acesso Negado" ou Dashboard se for seguro.
    return <Navigate to="/dashboard" replace />;
};

export default ProtectedRoute;